module.exports = __webpack_public_path__ + "static/media/slider.f4f61cc5.mp3";